export enum FeedbackConfirmation {
  Unknown = 0,
  PendingConfirmation = 1,
  Confirmed = 2,
  Rejected = 999
}
